export function getSubDomain(url) {
  const baseUrl = process.env.VUE_APP_BASE_URL || "egift.salonaz.com";
  const mainDomain = baseUrl.split('.').slice(-2).join('.');

  let regex = new RegExp(`(http:\\/\\/)?(([^.]+)\\.)?${mainDomain}`);
  if (url.includes('https')) {
    regex = new RegExp(`(https:\\/\\/)?(([^.]+)\\.)?${mainDomain}`);
  }

  const matches = regex.exec(url);
  console.log(matches);
  return matches && matches.length > 3 ? matches[3] : null;
}

export function formatPhoneNumber(phone) {
  //Filter only numbers from the input
  let cleaned = ("" + phone).replace(/\D/g, "");

  //Check if the input is of correct length
  let match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);

  if (match) {
    return "(" + match[1] + ") " + match[2] + "-" + match[3];
  }

  return null;
}

export function getNameFromUrl(url) {
  return /[^/]*$/.exec(url)[0];
}
